
import React, {useEffect, useState} from 'react';







function App(props) {  
  const [vorstand, setVorstand] = useState(); 
   useEffect(() => {
      let url = "./configs/vorstand.json";
      fetch(url)
          .then(res => res.json())
          .then(json => setVorstand(json))
      }, []);

    return (
      vorstand!=undefined?

      <div className="component-view animate" data-animate="blendin 3s">
         
         {
         vorstand.map(item=>(
      <div className="portrait-text-view" style={{maxWidth:500}} >
            <div className="text-item text-header">
            {item.header}
           </div>
           <img className="image-view" src={item.img}/>
          
           <div className="text-item ">
           {item.description}
           </div>            
       </div>
         ))
        }




    </div>:null
 
            );
        }
    
    export default App;